import Cookies from 'js-cookie'

export const useAttribution = () => {
    const isReferred = window.location.search.match(/grsf=/)

    if (isReferred) {
        Cookies.set('spritz_attribution', 'userReferral', { domain: 'spritz.finance' })
    }

    let attributionSource = Cookies.get('spritz_attribution')

    if (!attributionSource) {
        attributionSource = '(none)'
    }

    return {
        attributionSource,
    }
}
